import { getCookie, setCookie } from "./cookies.js";
import { calculator_used } from "./alalytics-helper.js";

// console.log('test off modal');
// ======= DEFAULT-MODAL WITH TRIGGERS =======//
// document.addEventListener("DOMContentLoaded", function () {

// 	// Updated logic for popup
	
// 	const modal_default = new bootstrap.Modal(document.getElementById("modal-default"));
// 	let cookies = getCookie('popupPauseUpdated');
// 	if ((cookies && cookies != 'true') || !cookies) {

// 		// Set timer
// 		if (!localStorage.timeTimeToShowModal) {
// 			localStorage.timeTimeToShowModal = new Date().getTime();
// 		}
		
// 		let popup = setInterval(() => {
// 			let secondsleft = Math.abs((localStorage.timeTimeToShowModal - new Date().getTime()) / 1000);
// 			if (secondsleft >= 120) {
// 				modal_default.show();
// 				setCookie('popupPauseUpdated',true,1);
// 				localStorage.timeTimeToShowModal = new Date().getTime();
// 				clearInterval(popup);
// 			}
// 		},1000)
		
// 	}

// 	// VARIABLES
// 	// const modal_default = new bootstrap.Modal(document.getElementById("modal-default"));
// 	// const links = document.querySelectorAll("a");

// 	// if (document.cookie.replace(/(?:(?:^|.*;\s*)popupPauseUpdated\s*\=\s*([^;]*).*$)|^.*$/, "$1") !== "false") {
// 	// 	var days7 = new Date(new Date().getTime() + 10080 * 60 * 1000);
// 	// 	document.cookie = "popupPauseUpdated=true; expires="+days7+"; path=/";
// 	// }

// 	// function alertCookie() {
// 	// 	console.log(document.cookie.replace(/(?:(?:^|.*;\s*)popupPauseUpdated\s*\=\s*([^;]*).*$)|^.*$/, "$1"));
// 	// }
// 	// alertCookie();

// 	// //SETUP LOCAL-STORAGE
// 	// if (document.body.classList.contains("home")) {
// 	// 	localStorage.pageWalkCount = 0;
// 	// 	localStorage.timeLeft = 120;
// 	// }

// 	// // TIMER
// 	// var downloadTimer = setInterval(function () {
// 	// 	if (localStorage.timeLeft <= 0 && document.cookie.replace(/(?:(?:^|.*;\s*)popupPauseUpdated\s*\=\s*([^;]*).*$)|^.*$/, "$1") !== "false") {
// 	// 		clearInterval(downloadTimer);
// 	// 		modal_default.show();
// 	// 		setpopupPauseUpdated();
// 	// 	}
// 	// 	localStorage.timeLeft -= 1;
// 	// }, 1000);

// 	// // LISTEN TO ALL LINKS
// 	// links.forEach((link) => {
// 	// 	link.addEventListener("click", function (e) {
// 	// 		parseInt(localStorage.pageWalkCount++);
// 	// 	});
// 	// });

// 	// //OPEN POPUP IF VISITED 4 LINKS IN ONE SESSION
// 	// if (localStorage.pageWalkCount == 4 && document.cookie.replace(/(?:(?:^|.*;\s*)popupPauseUpdated\s*\=\s*([^;]*).*$)|^.*$/, "$1") !== "false") {
// 	// 	modal_default.show();
// 	// 	clearInterval(downloadTimer);
// 	// 	setpopupPauseUpdated();
// 	// }

// 	// // DO NOT DISPLAY FOR A DAY - FUNCTION
// 	// function setpopupPauseUpdated() {
// 	// 	var days7 = new Date(new Date().getTime() + 10080 * 60 * 1000);
// 	// 	document.cookie = "popupPauseUpdated=false; expires="+days7+"; path=/";
// 	// 	// setTimeout(() => {
// 	// 	// 	var days7 = new Date(new Date().getTime() + 10080 * 60 * 1000);
// 	// 	// 	document.cookie = "popupPauseUpdated=true; expires="+days7+"; path=/";
// 	// 	// }, 86400);
// 	// }
// });

//======= DATA-LAYER =======//
window.dataLayer = window.dataLayer || [];

document.addEventListener("click", (e) => {
	if (e.target == document.querySelector("#submit-changes")) {
		// e.preventDefault();
		dataLayer.push({
			event: "profile_saved",
		});
	}
	if (e.target.classList.contains("post-vacancy-title")) {
		// e.preventDefault();
		dataLayer.push({
			event: "job_click",
			job_name: e.target.innerText,
			job_id: e.target.getAttribute("id"),
		});
	}
	// if (e.target.classList.contains("send-job-response")) {
	// 	// e.preventDefault();
	// 	dataLayer.push({
	// 		event: "job_applied",
	// 		job_name: e.target.dataset.name,
	// 		job_id: e.target.dataset.id
	// 	});
	// }
	if (e.target.classList.contains("php-analytics")) {
		// e.preventDefault();
		calculator_used(e.target);
	}
});

document.addEventListener(
	"change",
	(e) => {
		if (e.target.classList.contains("analytics")) {
			calculator_used(e.target);
		}
	},
	false
);

document.addEventListener(
	"click",
	(e) => {
		if (e.target.closest(".click__analytics")) {
			calculator_used(e.target);
		}
		if (e.target.closest(".list-group-item") && e.target.closest(".list-group-item").closest(".select__analytics")) {
			calculator_used(e.target.closest(".select__analytics"));
		}
	},
	false
);

if (document.body.classList.contains("post-type-archive-vacancy")) {
	document.querySelectorAll(".filter-form .analytics-filter").forEach((element) => {
		element.addEventListener("change", (e) => {
			let value = e.target.value;
			if (!value) {
				value = "default";
			}
			dataLayer.push({
				event: "filter_applied",
				filter_name: e.target.name,
				filter_value: value,
			});
		});
	});
}

// Singup by cookies
let singup_cookie = getCookie("singup");
if (singup_cookie) {
	dataLayer.push({
		event: "sign_up_success",
		label: singup_cookie,
	});
	document.cookie = "singup" + "=; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT;";
}

// Singin by cookies
let singin_cookie = getCookie("singin");
if (singin_cookie) {
	dataLayer.push({
		event: "login_success",
		label: singin_cookie,
	});
	document.cookie = "singin" + "=; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT;";
}


// Block register button

const register_form =  document.getElementById("register_form");
const register_form_button =  document.getElementById("register_form_button");
if (typeof(register_form) !== 'undefined' && register_form != null && typeof(register_form_button) !== 'undefined' && register_form_button != null ) {
	register_form.addEventListener("submit", () => {
		register_form_button.classList.add('loading');
		register_form_button.setAttribute("disabled", "");
	});
}